import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { PipesSharedModule } from '@shared/pipes-shared/pipes-shared.module';
import { MutualModule } from '@shared/mutual/mutual.module';
import {
  BatchImportLoadingComponent,
  BatchNotificationComponent,
  BatchProcessErrorNotificationComponent,
  BatchProcessPartialListNotificationComponent,
  BatchProcessPartialNotificationComponent,
  BatchSendPartialNotificationComponent,
  BatchSendPendingNotificationComponent,
  BatchSendSuccessNotificationComponent,
} from '@shared/batch-import-mutual/components';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    BatchNotificationComponent,
    BatchProcessPartialNotificationComponent,
    BatchProcessErrorNotificationComponent,
    BatchSendSuccessNotificationComponent,
    BatchSendPartialNotificationComponent,
    BatchProcessPartialListNotificationComponent,
    BatchImportLoadingComponent,
    BatchSendPendingNotificationComponent,
  ],
  imports: [CommonModule, MutualModule, TranslateModule, PipesSharedModule, RouterModule],
  exports: [
    BatchNotificationComponent,
    BatchProcessPartialNotificationComponent,
    BatchProcessErrorNotificationComponent,
    BatchSendSuccessNotificationComponent,
    BatchSendPartialNotificationComponent,
    BatchProcessPartialListNotificationComponent,
    BatchImportLoadingComponent,
    BatchSendPendingNotificationComponent,
  ],
})
export class BatchImportMutualModule {}
